import { createApiClient } from '../../../../../api/apiClient';
import { OrderRulesLastRefreshData, OrderRulesLastRefreshResponse } from './types';

// ─── API: GET /api/order-rules/lastRefresh ────────────────────────────────────

/**
 * Fetches the last-refresh timestamp for the given Databricks table.
 *
 * @param tableName - e.g. "DBX_FACT_WEEKLY_AVG_QTY", "DBX_FACT_MAX_POTENTIAL",
 *                    or "DBX_FACT_ORDERRULECHECK"
 */
export const fetchOrderRulesLastRefresh = async (
  tableName: string,
): Promise<OrderRulesLastRefreshData> => {
  const api = createApiClient();
  const res = await api.get<OrderRulesLastRefreshResponse>('/order-rules/lastRefresh', {
    params: { tableName },
  });
  return (res.data as any)?.data ?? {};
};
